'use client';

import { createRetryController, type RetryController } from 'elowen-plugin-shared/retry';

export type ReconnectController<T = void> = RetryController<T>;
export type ReconnectOptions<T> = Omit<Parameters<typeof createRetryController<T>>[0], 'mode'>;

/** One finite connection episode. The adapter owns readiness and the entire transport lifetime.
 * Health/focus triggers use start(); manual Retry, network recovery or one foreground return may restart(). */
export function createReconnectController<T>(options: ReconnectOptions<T>): ReconnectController<T> {
  return createRetryController({ ...options, mode: 'connection' });
}
